import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { apiGet, apiPost, apiPut, apiDelete } from "helpers/apiService";
import SafeField from "helpers/SafeField";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";

const EmailTargetType = () => {
  const [list, setList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    fetchList();
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  /* ================= FETCH ================= */

  const fetchList = () => {
    apiGet("EmailTargetType/all")
      .then(res => setList(res.data))
      .catch(() => toast.error("Failed to load data"));
  };

  /* ================= CREATE ================= */

  const handleCreate = (values, { setSubmitting, resetForm }) => {
    toast.loading("Saving...");

    apiPost("EmailTargetType", values)
      .then(() => {
        toast.dismiss();
        toast.success("Saved successfully");
        fetchList();
        resetForm();
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Save failed");
      })
      .finally(() => setSubmitting(false));
  };

  /* ================= UPDATE ================= */

  const handleUpdate = (values, { setSubmitting }) => {
    toast.loading("Updating...");

    apiPut("EmailTargetType", values)
      .then(() => {
        toast.dismiss();
        toast.success("Updated successfully");
        fetchList();
        toggle();
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Update failed");
      })
      .finally(() => setSubmitting(false));
  };

  /* ================= DELETE ================= */

  const handleDelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
    }).then(result => {
      if (!result.isConfirmed) return;

      apiDelete(`EmailTargetType/${id}`)
        .then(() => {
          toast.success("Deleted successfully");
          fetchList();
        })
        .catch(() => toast.error("Delete failed"));
    });
  };

  const openEdit = item => {
    setSelected(item);
    setIsEdit(true);
    toggle();
  };

  /* ================= VALIDATION ================= */

  const validationSchema = Yup.object({
    emailTargetTypeTitle: Yup.string().required("Required"),
    emailTargetTypeFilter: Yup.string().required("Required"),
    emailTargetTypeObjectType: Yup.string().required("Required"),
  });

  return (
    <Container fluid className="page-content">
      <ToastContainer autoClose={2000} />
<Row className="mb20">
            <Col xl="12">
              <Breadcrumbs title="General Settings" breadcrumbItem="Email Target Type" />
            </Col>
          </Row>

      <Row>
        <Col xl="12">
          {/* ===== ADD FORM ===== */}
          <Card>
            <CardBody>
             

              <Formik
                initialValues={{
                  emailTargetTypeTitle: "",
                  emailTargetTypeFilter: "",
                  emailTargetTypeObjectType: "",
                  isActive: true,
                }}
                validationSchema={validationSchema}
                onSubmit={handleCreate}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <Label>Title *</Label>
                          <SafeField
                            name="emailTargetTypeTitle"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.emailTargetTypeTitle && touched.emailTargetTypeTitle
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <ErrorMessage
                            name="emailTargetTypeTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="3">
                        <FormGroup>
                          <Label>Filter *</Label>
                          <SafeField
                            name="emailTargetTypeFilter"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.emailTargetTypeFilter && touched.emailTargetTypeFilter
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="3">
                        <FormGroup>
                          <Label>Object Type *</Label>
                          <SafeField
                            name="emailTargetTypeObjectType"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.emailTargetTypeObjectType &&
                              touched.emailTargetTypeObjectType
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="2" className="">
                        <Button type="submit" color="primary" className="mt-4"> 
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>

          {/* ===== LIST ===== */}
          <Card>
            <CardBody>
              <h5>History</h5>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Filter</th>
                      <th>Object Type</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item, i) => (
                      <tr key={item.id || i}>
                        <td>{i + 1}</td>
                        <td>{item.emailTargetTypeTitle}</td>
                        <td>{item.emailTargetTypeFilter}</td>
                        <td>{item.emailTargetTypeObjectType}</td>
                        <td>{item.isActive ? "Active" : "Inactive"}</td>
                        <td>
                            <ActionEdit onClick={() => openEdit(item)} />{" "}
                            <ActionDelete onClick={() => handleDelete(item.id)} />
                         
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* ===== EDIT OFFCANVAS ===== */}
      <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
        <OffcanvasHeader toggle={toggle}>Update Target Type</OffcanvasHeader>
        <OffcanvasBody>
          <Formik
            enableReinitialize
            initialValues={selected}
            validationSchema={validationSchema}
            onSubmit={handleUpdate}
          >
            {({ handleChange }) => (
              <Form>
                <FormGroup>
                  <Label>Title *</Label>
                  <SafeField name="emailTargetTypeTitle" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup>
                  <Label>Filter *</Label>
                  <SafeField name="emailTargetTypeFilter" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup>
                  <Label>Object Type *</Label>
                  <SafeField
                    name="emailTargetTypeObjectType"
                    onChange={handleChange}
                    className="form-control"
                  />
                </FormGroup>

                <FormGroup check className="mb-3">
                  <SafeField type="checkbox" name="isActive" />
                  <Label check className="ms-2">Active</Label>
                </FormGroup>

                <Button type="submit" color="primary">
                  Update
                </Button>
              </Form>
            )}
          </Formik>
        </OffcanvasBody>
      </Offcanvas>
    </Container>
  );
};

export default EmailTargetType;
